module.exports = __webpack_public_path__ + "static/media/github.c654049a.svg";